import { ConfirmDialog, useToast } from "@nabble/ui";
import { removeTotp } from "../../../../api/secondFactors";
import { factorErrorMessage } from "./factorErrorMessage";

/** Confirms removing the authenticator app as a second factor. */
export function RemoveTotpDialog({ open, onClose, onRemoved }: { open: boolean; onClose: () => void; onRemoved: () => void }): React.JSX.Element {
  const { show } = useToast();
  return (
    <ConfirmDialog
      open={open}
      tone="danger"
      icon="smartphone"
      title="Remove authenticator app"
      description="You'll no longer be able to sign in with codes from the app. Make sure you have another way to verify."
      confirmLabel="Remove"
      onClose={onClose}
      onConfirm={async () => {
        try {
          await removeTotp();
          show({ title: "Authenticator app removed", tone: "success" });
          onRemoved();
        } catch (err) {
          show({ title: "We couldn't remove it", text: factorErrorMessage(err), tone: "danger" });
        }
      }}
    />
  );
}
